@if (!incident) {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 bc-mono-white radius-16 p-24">
        <div class="t2-semi-bold">{{ 'i18n_af_incidentCommonInformation' | translate }}</div>
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </div>
}

@if (incident) {
    <mat-expansion-panel
        [hideToggle]="Spinner.isShown('initForms')"
        [disabled]="Spinner.isShown('initForms')">
        <mat-expansion-panel-header class="w-100"
                                    [class.loading]="Spinner.isShown('initForms')"
                                    fxLayout="start space-between">
            <mat-panel-title class="no-wrap t2-semi-bold">
                {{ 'i18n_af_incidentCommonInformation' | translate }}
            </mat-panel-title>
            @if (Spinner.isShown('initForms')) {
                <mat-panel-description fxLayoutAlign="end">
                    <ui-kit-spinner [diameter]="16" [strokeWidth]="3" spinnerIds="initForms"/>
                </mat-panel-description>
            }
        </mat-expansion-panel-header>
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </mat-expansion-panel>
}

<ng-template #formTemplate>
    @if (form) {
        <form [fxHide]="Spinner.isShown('initForms')" [formGroup]="form" fxLayout="column" fxLayoutAlign="start start"
              class="w-824 mt-24"
              (submit)="submit()">
            @if (form.controls.type) {
                <af-dictionary-selector dictionaryName="incident_type"
                                        class="min-max-w-400"
                                        [control]="form.controls.type"
                                        [excludeFromDictionary]="excludeIncidentTypes"
                                        [predefinedValue]="incident?.type"
                                        [disabled]="isTypeDisabled"
                                        label="i18n_af_labelFraudType"
                                        placeholder="i18n_af_placeholderFraudType"/>
            }
            <div class="grid-form-container mt-24">
                @if (form.controls.fraudType) {
                    <af-dictionary-selector dictionaryName="fraud_type"
                                            [control]="form.controls.fraudType"
                                            [predefinedValue]="incident?.fraud_type"
                                            [isDependentDictionary]="true"
                                            [parentDictionaryFormControl]="form.controls.type"
                                            [disabled]="isFraudTypeDisabled"
                                            label="i18n_af_labelFraudSubType"
                                            placeholder="i18n_af_placeholderFraudSubType"/>
                }
                @if (form.controls.basedOn) {
                    <af-dictionary-selector
                        dictionaryName="based_on"
                        [control]="form.controls.basedOn"
                        [excludeFromDictionary]="excludeBasedOn"
                        [predefinedValue]="incident?.based_on"
                        label="i18n_af_labelBasedOn"
                        placeholder="i18n_af_placeholderBasedOn"/>
                }
                @if (form.controls.governmentOrganizations) {
                    <af-dictionary-selector
                        #governmentOrganizationsSelector
                        dictionaryName="bin"
                        [control]="form.controls.governmentOrganizations"
                        [filterDictionaryBy]="['IO']"
                        [predefinedValue]="incident?.governmentBin"
                        [shouldAddClearOption]="!isGovernmentOrganizationsRequired"
                        label="i18n_af_labelGovernmentOrganization"
                        placeholder="i18n_af_placeholderGovernmentOrganizations"/>
                }
                @if (form.controls.relatedOrganizations) {
                    <af-dictionary-selector
                        dictionaryName="bin"
                        selectedCountPlaceholder="i18n_af_placeholderOrganizationSelectedCount"
                        [isMultiple]="true"
                        [predefinedValue]="incident?.related"
                        [filterDictionaryBy]="['BANK', 'PAYM', 'MFO', 'MOBILE_OPERATOR']"
                        [control]="form.controls.relatedOrganizations"
                        label="i18n_af_labelRelatedOrganization"
                        placeholder="i18n_af_placeholderRelatedOrganizations"/>
                }
            </div>
            @if (form.controls.description) {
                <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-24">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelDescription' | translate }}*</div>
                    <mat-form-field class="mt-4 w-100"
                                    [class.value-not-empty]="form.enabled && form.value.description">
            <textarea matInput
                      #descriptionArea
                      [maxlength]="DESCRIPTION_MAX_LENGTH"
                      class="resize-none pt-12 pb-12"
                      (keydown.control.enter)="submit()"
                      [placeholder]="'i18n_af_placeholderIncidentDescription' | translate"
                      formControlName="description"></textarea>
                        <mat-hint align="start" class="t5 c-primary-gray-600">{{ descriptionArea.value.length }}
                            / {{ DESCRIPTION_MAX_LENGTH }}
                        </mat-hint>
                        @if (form.controls.description.hasError('minlength')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationDescriptionMinLength' | translate: {min: DESCRIPTION_MIN_LENGTH} }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            }
            @if (form.controls.files) {
                <af-files
                    class="w-100 mt-40"
                    [attachments]="incident?.attachments"
                    [excludeItemsWithCode1]="true"
                    [form]="form.controls.files"
                    [bucket]="BucketName.INCIDENT_FILES"/>
            }
            @if (!incident) {
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
                    <ui-kit-button spinnerId="submit"
                                   [disabled]="form.invalid"
                                   [label]="'i18n_af_buttonNext' | translate"/>
                    <ui-kit-button class="ml-16"
                                   color="accent"
                                   buttonType="button"
                                   type="text"
                                   (clickListener)="cancel.emit()"
                                   [label]="'i18n_af_buttonCancel' | translate"/>
                </div>
            }
        </form>
    }
</ng-template>
